import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useCompany } from "./context/CompanyContext";
import { canAccessPath, fallbackRoute } from "../util/accessControl";

// Guarda de rota do controle de acesso: esconder o item do menu não basta,
// porque a URL continua acessível (e o login sempre cai em /homev2).
export default function RequireScreenAccess({ children }) {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId, accessControl, slug } = useCompany();
  const location = useLocation();
  const nav = useNavigate();

  const position = currentUser?.position;
  const loaded = companyId > 0;
  const allowed =
    !loaded ||
    !position ||
    canAccessPath(accessControl, position, location.pathname, location.search);
  const target =
    loaded && !allowed
      ? fallbackRoute(accessControl, position, location.pathname, location.search)
      : null;

  useEffect(() => {
    if (!target) return;
    nav(`/${slug}/${target}`, { replace: true });
  }, [target, slug, nav]);

  if (allowed) return children;

  // Perfil sem acesso a nenhuma tela: não há para onde redirecionar.
  if (!target)
    return (
      <div className="cust-page">
        <div className="cust-card" style={{ padding: 24 }}>
          Seu perfil não tem acesso a nenhuma tela. Fale com o administrador da
          conta.
        </div>
      </div>
    );

  return null;
}
